import React, { useState } from "react";
import {
  Text,
  Stack,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
  IconButton,
  Button,
} from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
// import { authSetUser } from "../../../store/actions/authAction";
// import { useDispatch } from "react-redux";
import { loginUser } from "../services/login";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { authSetUser } from "../../../store/actions/authAction";
import { acceptInvite } from "../../invitation/services/inviteService";
import { useToast } from "@chakra-ui/react";

export const SignIn = ({ setSignUpp, email, setEmail }) => {
  // const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const toast = useToast();

  const handleLogin = async () => {
    setLoading(true);
    try {
      const data = await loginUser({ email, password }, setLoading);
      // update redux auth state from backend user payload
      try {
        dispatch(authSetUser(data));
      } catch (err) {
        console.warn("failed to dispatch user", err);
      }
      // after successful login, handle next redirect
      const params = new URLSearchParams(location.search);
      const next = params.get("next");
      if (next) {
        const decoded = decodeURIComponent(next);
        // auto-accept invitation links of the form /invitations/:token
        if (decoded.startsWith("/invitations/")) {
          const token = decoded.split("/").pop();
          try {
            await acceptInvite(token);
            toast({
              title: "Invitation accepted",
              description: "You have been added to the estate.",
              status: "success",
              duration: 5000,
              isClosable: true,
            });
          } catch (err) {
            console.error("accept invite failed", err);
            toast({
              title: "Invitation",
              description: err?.message || "Failed to accept invitation",
              status: "error",
              duration: 5000,
              isClosable: true,
            });
          }
          navigate("/select-account");
          return;
        }
        navigate(decoded);
        return;
      }
      navigate("/select-account");
    } catch (err) {
      // loginUser already shows errors; nothing else to do here
    } finally {
      setLoading(false);
    }
  };

  return (
    <Stack m={"auto"} py={"30px"} width={["100%", "80%"]} px={["20px", "20px"]}>
      <Text
        color={"primary.500"}
        fontSize="40px"
        fontWeight={"semibold"}
        mb={"-10px"}
      >
        Welcome Back!
      </Text>
      <Text fontSize={"18px"} color={"gray.600"} fontWeight={500}>
        Get started, pay your bills, manage utilities, track expenses, and take
        full control of your estate.
      </Text>
      <FormControl cursor={"pointer"} borderColor="#CFE5E2">
        <FormLabel
          htmlFor="email"
          color={"#4D4A4A"}
          fontSize="18px"
          pt={"17px"}
        >
          Email
        </FormLabel>
        <Input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <FormLabel
          htmlFor="password"
          color={"#4D4A4A"}
          fontSize="18px"
          pt={"17px"}
        >
          Password
        </FormLabel>
        <InputGroup>
          <Input
            id="password"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <InputRightElement>
            <IconButton
              variant="ghost"
              size="sm"
              aria-label={showPassword ? "Hide password" : "Show password"}
              icon={showPassword ? <ViewOffIcon /> : <ViewIcon />}
              onClick={() => setShowPassword((v) => !v)}
            />
          </InputRightElement>
        </InputGroup>
        <Text
          cursor="pointer"
          color={"#474747"}
          fontSize="13px"
          mb="15px"
          fontWeight={400}
          onClick={() => setSignUpp("forgot")}
        >
          Forgot Password?
        </Text>
      </FormControl>
      <Button
        bg={"primary.500"}
        size={"md"}
        color="#FFFFFF"
        w="100%"
        fontWeight={400}
        // mt="50px"
        fontSize={"18px"}
        isLoading={loading}
        _hover={{ bg: "primary.600" }}
        onClick={handleLogin}
      >
        Sign In
      </Button>
      <Text
        textAlign={"center"}
        fontSize="16px"
        color="#000000"
        fontWeight={400}
      >
        Don't have an account?{" "}
        <Text
          as="span"
          color="primary.500"
          onClick={() => setSignUpp("signup")}
          cursor="pointer"
        >
          Sign Up.
        </Text>
      </Text>
    </Stack>
  );
};
